import {
    applicationMethodFromInt,
    ProductLocation,
} from 'src/components/CustomisationPage/feature/customisation.types';

import { getCustomisationLocations_products_items_locations } from '../../../queries/__generated__/getCustomisationLocations';

export function cleanLocations(locs: (getCustomisationLocations_products_items_locations | null)[]): ProductLocation[] {
    const placeholder = require('../../../../static/img/placeholder.jpg');
    const array: ProductLocation[] = [];
    locs.forEach((item) => {
        if (!item) return;
        array.push({
            name: item.name || 'unknown',
            image_url: item.image_url !== null ? item.image_url : placeholder,
            method: applicationMethodFromInt(item.type),
        });
    });
    return array;
}
